import { adminToolsReducers } from '@/modules/AdminTools/redux';
import { userManagementReducers } from '@/modules/dashboard/components/UsersManagement/redux';
import { housingReducers } from '@/modules/Housing/redux';
import { aspynMigratorReducer } from '@/modules/AspynMigrator/redux';
import { addressesReducer } from '@/redux/addresses';
import { approvalReducer } from '@/redux/approval';
import { areasReducer } from '@/redux/areas-new';
import { authReducer } from '@/redux/auth';
import { clusterStatsReducer } from '@/redux/clusters';
import { contractsReducer } from '@/redux/contracts';
import { errorsReducer } from '@/redux/errors';
import { filesReducer } from '@/redux/files';
import { loadingReducer } from '@/redux/loading';
import { notificationsReducer } from '@/redux/notifications';
import { onboardingReducer } from '@/redux/onboarding';
import { polygonsReducer } from '@/redux/polygons';
import { recruitersReducer } from '@/redux/recruiters';
import { repsReducer } from '@/redux/reps';
import {
  soRepsReducer,
  soSeasonsReducer,
  soStatsReducer,
  soTeamsReducer,
} from '@/redux/sales-operations';
import { seasonsReducer } from '@/redux/seasons';
import { teamsReducer } from '@/redux/teams';
import { toastsReducer } from '@/redux/toasts';
import {
  manageUsersReducer,
  manageUserGroupsReducer,
  manageUserDetailsReducer
} from '@/redux/users';
import { manageSalesTeamsReducer } from '@/redux/sales-teams';
import { manageSalesAreasReducer } from '@/redux/sales-areas';

const createRootReducer = () => ({
  auth: authReducer,
  reps: repsReducer,
  contracts: contractsReducer,
  recruiters: recruitersReducer,
  loading: loadingReducer,
  errors: errorsReducer,
  files: filesReducer,
  addresses: addressesReducer,
  onboarding: onboardingReducer,
  area: areasReducer,
  teams: teamsReducer,
  polygons: polygonsReducer,
  clusters: clusterStatsReducer,
  seasons: seasonsReducer,
  soStats: soStatsReducer,
  soReps: soRepsReducer,
  soTeams: soTeamsReducer,
  soSeasons: soSeasonsReducer,
  manageUsers: manageUsersReducer,
  manageUserDetails: manageUserDetailsReducer,
  manageUserGroups: manageUserGroupsReducer,
  manageSalesAreas: manageSalesAreasReducer,
  manageSalesTeams: manageSalesTeamsReducer,
  toasts: toastsReducer,
  approval: approvalReducer,
  notifications: notificationsReducer,
  aspynMigrator: aspynMigratorReducer,
  ...adminToolsReducers(),
  ...housingReducers(),
  ...userManagementReducers(),
});

export default createRootReducer;
